import React from "react";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

type ReceiptsValue = "has_receipt" | "no_receipt" | "requires_receipt";

const options: FilterMultiselectOption[] = [
    {
        value: "has_receipt",
        label: "Has receipt",
        searchableLabel: "has receipt",
    },
    { value: "no_receipt", label: "No receipt", searchableLabel: "no receipt" },
    {
        value: "requires_receipt",
        label: "Requires receipt",
        searchableLabel: "requires receipt",
    },
];

export const ReceiptsFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const value: ReceiptsValue[] = [
        ...(filters.hasReceipt ? ["has_receipt" as const] : []),
        ...(filters.noReceipt ? ["no_receipt" as const] : []),
        ...(filters.requiresReceipt ? ["requires_receipt" as const] : []),
    ];

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                searchable={false}
                options={options}
                value={value}
                onChange={(val) => {
                    const selected = val as ReceiptsValue[];
                    onChange({
                        hasReceipt: selected.includes("has_receipt")
                            ? true
                            : undefined,
                        noReceipt: selected.includes("no_receipt")
                            ? true
                            : undefined,
                        requiresReceipt: selected.includes("requires_receipt")
                            ? true
                            : undefined,
                    });
                }}
                name="receipts"
                onBlur={noop}
            />
        </div>
    );
};
